import moment from 'moment';

export const DEBUG = process.env.NODE_ENV !== 'production';
export const API_ADDRESS = process.env.NODE_ENV === 'production' ? 'https://aplikacja-alternator.pl': 'http://localhost:8000';
export const SITE_ADDRESS = process.env.NODE_ENV === 'production' ? 'https://serwisbrozek.pl' : 'http://localhost:8080';
export const FORM_TIMEOUT = DEBUG ? moment.duration(1, 'seconds') : moment.duration(45, 'seconds');
export const DATA_PROTECTION_AGREEMENT_PATH = `${SITE_ADDRESS}/klauzula-rodo-serwis-brozek-aleksandrow-kujawski.pdf`;
